import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import CarImage from "../assets/images/eror-texi.png";
import CarImage02 from "../assets/images/bg.jpg";
import * as XLSX from "xlsx";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;
function ViewTaxiDetails() {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [carList, setCarList] = useState([]);

  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);

  const [selected, setSelected] = useState();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [hotelId, setHotelId] = useState();
  const debouncedSearchText = useDebounce(searchText, 300);
  const params = useParams();
  const { confirm } = Modal;

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  useEffect(() => {
    request({
      url: `/admin/driver/view-driver/${params.id}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data.data);
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [params.id]);

  useEffect(() => {
    request({
      url: `/admin/usercar/view-car/${params.id}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data.data);
        setLoading(false);
        setCarList(data.data);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [params.id]);

  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Driver Details"
              extra={<></>}
            >
              <div className="driver-details">
                <h4>Driver details</h4>
                <div className="dlx-main-box">
                  <div className="dlx-box">
                    <h6>Driver Name:</h6>
                    <p>{list ? list.name : "--"}</p>
                  </div>
                  <div className="dlx-box">
                    <h6>Email:</h6>
                    <p>{list ? list.email : "--"}</p>
                  </div>
                  <div className="dlx-box">
                    <h6>Phone Number:</h6>
                    <p>
                      {list
                        ? "+ " + list.countryCode + "-" + list.mobileNumber
                        : ""}
                    </p>
                  </div>
                  <div className="dlx-box">
                    <h6>Driving Lisense:</h6>
                    <div className="car-filtter">
                      {list.drivingLicence ? (
                        <a
                          href={`https://b2btobacco.s3.amazonaws.com/${list.drivingLicence}`}
                          target="_blank"
                        >
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.drivingLicence
                            }
                          />
                        </a>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="dlx-box">
                    <h6>Driver Profile:</h6>
                    <div className="car-filtter">
                      {list.profileImage ? (
                        <a
                          href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                          target="_blank"
                        >
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.profileImage
                            }
                          />
                        </a>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="driver-details mt-3">
                <h4>Car details</h4>
                <div className="dlx-main-box">
                  <div className="dlx-box">
                    <h6>Car Name:</h6>
                    <p>{carList ? carList.carName : "--"}</p>
                  </div>

                  <div className="dlx-box">
                    <h6>Car Modal:</h6>
                    <p>
                      {carList && carList
                        ? carList.carModel && carList.carModel.name
                        : "--"}
                    </p>
                  </div>
                  <div className="dlx-box">
                    <h6>Car Make:</h6>
                    <p>
                      {carList && carList
                        ? carList.carMake && carList.carMake.name
                        : "--"}
                    </p>
                  </div>
                  <div className="dlx-box">
                    <h6>Car Type:</h6>
                    <p>
                      {carList && carList
                        ? carList.carType && carList.carType.name
                        : "--"}
                    </p>
                  </div>
                  <div className="dlx-box">
                    <h6>Car Number:</h6>
                    <p>
                      {carList  ? carList.carNumber : "--"}
                    </p>
                  </div>
                  <div className="dlx-box">
                    <h6>Car images:</h6>
                    <div className="car-filtter">
                      <a
                        href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                        target="_blank"
                      >
                        {list && list.car && list.car.carImage ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.carImage
                            }
                          />
                        ) : (
                          ""
                        )}
                      </a>
                      <a
                        href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                        target="_blank"
                      >
                        {list && list.car && list.car.backNumberPlate ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.backNumberPlate
                            }
                          />
                        ) : (
                          ""
                        )}
                      </a>
                      <a
                        href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                        target="_blank"
                      >
                        {list && list.car && list.car.frontNumberPlate ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.frontNumberPlate
                            }
                          />
                        ) : (
                          ""
                        )}
                      </a>
                      <a
                        href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                        target="_blank"
                      >
                        {list && list.car && list.car.carPuc ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.carPuc
                            }
                          />
                        ) : (
                          ""
                        )}
                        {list && list.car && list.car.carPermit ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.carPermit
                            }
                          />
                        ) : (
                          ""
                        )}
                      </a>
                      <a
                        href={`https://b2btobacco.s3.amazonaws.com/${list.profileImage}`}
                        target="_blank"
                      >
                        {list && list.car && list.car.chassisNumber ? (
                          <img
                            src={
                              "https://b2btobacco.s3.amazonaws.com/" +
                              list.car.chassisNumber
                            }
                          />
                        ) : (
                          ""
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </Main>
  );
}

export default ViewTaxiDetails;
